// Vendor libraries
import { bootstrapAppModule } from 'NewAngular/utils/app-bootstrapping';
// Modules
import { MutualFundsPerformanceBetaModule } from './app.module';
bootstrapAppModule(MutualFundsPerformanceBetaModule);
